import React from 'react'
import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Cnh from '../components/Cnh'

const CnhPage = () => {
    return (
        <main className="h-full bg-[#111827] overflow-auto">
            <div className="mx-auto max-w-screen-xl h-full w-full">
                <LandingNavbar />
                <Cnh />
            </div>
          </main>
    )
}

export default CnhPage